/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
import { useTimeout } from "../../hooks";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";
import { useState } from "react";
import clsx from "clsx";
import Box from "@mui/material/Box";

function BASELoading(props) {
  const { delay = false } = props;
  const [showLoading, setShowLoading] = useState(!delay);

  useTimeout(() => {
    setShowLoading(true);
  }, delay);

  return (
    <div
      className={clsx(
        "flex flex-1 flex-col items-center justify-center p-24",
        !showLoading && "hidden"
      )}
      id="base-loading-screen"
    >
      <Box sx={{ overflow: "visible" }}>
        <svg
          width="64"
          height="48"
          viewBox="0 0 64 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          id="logo"
        >
          <path
            d="M2.2361 32L32 17.118L61.7639 32L32 46.882L2.2361 32Z"
            stroke="#1D2A44"
            strokeWidth="2"
            id="logo-base"
          />
          <path 
            d="M38 19L42 21L39.7639 22.118L35.7639 20.118L38 19Z" 
            fill="#162033"
            id="logo-mid-shadow-1"
          />
          <path 
            d="M56 28L60 30L57.7639 31.118L53.7639 29.118L56 28Z" 
            fill="#162033"
            id="logo-mid-shadow-2"
          />
          <path 
            d="M4 30L8 28L10.24 29.12L6.24 31.12L4 30Z" 
            fill="#162033"
            id="logo-mid-shadow-3"
          />
          <path
            d="M32 8L0 24L14 31L46 15L32 8Z"
            fill="#013BB1"
            id="logo-mid-1"
          />
          <path
            d="M50 17L18 33L32 40L64 24L50 17Z"
            fill="#013BB1"
            id="logo-mid-2"
          />
          <path 
            d="M3 22.5L14 28L28 21L17 15.5L14.7639 16.618L23.5279 21L14 25.7639L5.23607 21.382L3 22.5Z"
            fill="#012C85"
            id="logo-top-shadow-1"
          />
          <path 
            d="M43 13.5L40.7639 12.382L32 16.7639L23.2361 12.382L21 13.5L32 19L43 13.5Z"
            fill="#012C85"
            id="logo-top-shadow-2"
          />
          <path 
            d="M21 31.5L32 37L46 30L35 24.5L32.7639 25.618L41.5279 30L32 34.7639L23.2361 30.382L21 31.5Z"
            fill="#012C85"
            id="logo-top-shadow-3"
          />
          <path 
            d="M61 22.5L58.7639 21.382L50 25.7639L41.2361 21.382L39 22.5L50 28L61 22.5Z"
            fill="#012C85"
            id="logo-top-shadow-4"
          />
          <path
            d="M25.7639 16L14 21.882L2.23607 16L14 10.118L25.7639 16Z"
            stroke="#80F2E7"
            strokeWidth="2"
            className="logo-top"
            id="logo-top-1"
          />
          <path
            d="M43.7639 7L32 12.882L20.2361 7L32 1.11803L43.7639 7Z"
            stroke="#80F2E7"
            strokeWidth="2"
            className="logo-top"
            id="logo-top-2"
          />
          <path
            d="M43.7639 25L32 30.882L20.2361 25L32 19.118L43.7639 25Z"
            stroke="#80F2E7"
            strokeWidth="2"
            className="logo-top"
            id="logo-top-3"
          />
          <path
            d="M61.7639 16L50 21.882L38.2361 16L50 10.118L61.7639 16Z"
            stroke="#80F2E7"
            strokeWidth="2"
            className="logo-top"
            id="logo-top-4"
          />
        </svg>
      </Box>
      <Typography
        className="text-13 sm:text-20 font-medium -mb-16 mt-32"
        color="text.secondary"
      >
        Loading
      </Typography>
    </div>
  );
}

BASELoading.propTypes = {
  delay: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
};

// BASELoading.defaultProps = {
//   delay: false,
// };

export default BASELoading;
